<template>
    <div class="topclass-opt-in">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xl-4 text-center p-0">
                    <div class="topclass-opt-in-wrap">
                        <div class="topclass-opt-in-banner"><img srcset="" :src="require('@/assets/galerias/banner_topclass.jpg')" alt=" " class="img-fluid mx-auto" /></div>
                        <div class="topclass-opt-in-contenedor py-3 px-4">
                            <div class="topclass-opt-in-linea mb-2"></div>
                            <p class="topclass-opt-in-eb text-black">Confirmación de Suscripción Topclass</p>
                            <div class="topclass-opt-in-pasos my-2">
                                <div class="topclass-opt-in-circle topclass-opt-in-circle-border"><span><img :src="require('@/assets/galerias/checkmark.svg')" class="img-fluid" alt=""></span></div>
                                <div class="topclass-opt-in-pasos-linea"></div>
                                <div class="topclass-opt-in-circle topclass-opt-in-circle-fill"><span>02</span></div>
                            </div>
                            <p class="text-black fw-bold">Acepto la activación y suscripción del servicio Topclass por $3.490/mes que se cobrará a mi boleta o descontará de mi saldo Movistar.</p>
                            <div v-if="pinInput">
                                <input
                                    v-model="pin"
                                    :class="{
                                        'form-control': true,
                                        'form-control-lp': true,
                                        'text-center': true,
                                        'center-input': true,
                                        'is-invalid': validated && (pin == '' || !isPinValid),
                                        'is-valid': validated && isPinValid && pin != ''
                                        }"
                                    type="text"
                                    maxlength="12"
                                    placeholder="Ingresar Código PIN"
                                    ref="pin"
                                />
                                <div class="invalid-feedback">Debe ingresar el pin</div>
                                <div class="valid-feedback" v-if="validated"></div>
                            </div>
                            <button class="btn btn-verde d-block my-1" @click="acepto" role="button">
                                <span>Acepto</span>
                                <a  target="_blank" class="btn-verde-aceptar text-white">Términos y condiciones</a>
                            </button>

                            <a
                                class="btn btn-gris d-block my-1" @click="regresar" role="button">No acepto </a><small class="topclass-opt-in-terminos text-start d-block">
                            <span class="fw-bold text-uppercase">Al suscribirse estas aceptando:</span>
                            <ul>
                                <li>Suscripción mensual con cobro recurrente</li>
                                <li>Cobro en mi boleta o saldo Movistar</li>
                                <li>Para mi línea Movistar +{{telefono}}.</li>
                                <li>Para darte de baja envía la palabra “Salir” al 7600</li>
                            </ul>
                        </small></div>
                    </div>
                </div>
            </div>
            <b-modal v-model="modalMomento"
                     :busy="true"
                     centered
                     hide-footer
                     hide-header-close
                     no-close-on-backdrop
                     v-bind:title="Suscribirse">
                <div class="form-group text-center">
                    <div class="label-movistar">
                        <p class="text-black mb-1">{{mensajeMomento}}</p>
                    </div>
                    <br>
                    <label class="label-movistar">Cargando.</label>
                    <br>
                </div>
            </b-modal>
            <b-modal v-model="modalMensaje"
                     :busy="true"
                     centered
                     hide-footer
                     hide-header-close
                     no-close-on-backdrop
                     v-bind:title="Suscribirse">
                <div class="form-group text-center">
                    <br>
                    <label class="label-movistar">La línea ya está inscrita al servicio Topclass</label>
                    <br>
                </div>
            </b-modal>
            <b-modal v-model="modalError"
                     :busy="true"
                     centered
                     hide-footer
                     hide-header-close
                     no-close-on-backdrop
                     v-bind:title="Suscribirse">
                <div class="form-group text-center">
                    <br>
                    <label class="label-movistar">Ha ocurrido un problema por favor inténtelo más tarde.</label>
                    <br>
                </div>
            </b-modal>
            <b-modal v-model="modalError302"
                     :busy="true"
                     centered
                     hide-footer
                     hide-header-close
                     no-close-on-backdrop
                     v-bind:title="Suscribirse">
                <div class="form-group text-center">
                    <br>
                    <label class="label-movistar">Hola! Movistar te informa que puedes contratar un máximo de 3 servicios digitales por línea, para mas información <a href="https://mvst.cl/trvhQs" target="_blank">https://mvst.cl/trvhQs</a></label>
                    <br>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>

import {isValidPin} from "../utilities/util";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";

export default {
    name: "MLPConfirm",
    components: {bModal},
    directives: {
        "b-modal": bModalDirective,
    },
    props:[
        "telefono",
        "pin",
        "inscriptionId",
        "pinInput",
    ],
    computed: {
        isPinValid() {
            if (this.pin.length == 4) {
                return isValidPin(this.pin.toString());
            }else {
                return false;
            }
        },
    },
    data() {
        return {
            validated: false,
            modalMomento: false,
            modalMensaje: false,
            modalError: false,
            mensajeMomento: "",
            modalError302: false,
        };
    },
    methods: {
        regresar(){
            window.location.reload();
        },
        acepto(){
            this.validated = false;
            this.mensajeMomento = "Confirmación de Suscripción";
            this.modalMomento = true;
            if (this.isPinValid || !this.pinInput) {
                this.$api
                    .service_setPinE_movistar({
                        inscriptionId: this.inscriptionId,
                        pin: this.pin,
                    })
                    .then((response) => {
                        if(response.data.status === 302 && response.data.success === false && response.data.description === "LIMIT_EXCEEDED") {
                            this.modalMomento = false;
                            this.modalError302 = true;
                            setTimeout(() => {
                                this.modalError302 = false;
                                window.location.reload();
                            }, 4000);
                        }else if (response.data.success === true && response.data.status === 200) {
                            this.modalMomento = false;
                            this.$router.push({
                                name: "LpMovistarFelicitaciones",
                                params: {
                                    msisdn: "56" + this.telefono,
                                }
                            });
                        } else {
                            this.modalMomento = false;
                            this.modalError = true;
                            setTimeout(() => {
                                this.modalError = false;
                                window.location.reload();
                            }, 4000);
                        }
                    });
            }else {
                this.validated = true;
                this.modalMomento = false;
            }
            },
    },
};
</script>
